import { Breakpoint } from '@24i/nxg-sdk-smartott/src/utils/styles/constants';
import styled from 'styled-components';
export const BaseModalContentsWrapper = styled.div `
    width: 100%;
    height: fit-content;
    align-items: flex-end;
    position: fixed;
    bottom: 8%;

    & .swiper-container {
        overflow: visible;
    }

    & .swiper-slide:hover {
        z-index: 10;
    }

    @media (max-width: ${Breakpoint.MD}px) {
        bottom: 30px;
    }
`;
//# sourceMappingURL=index.js.map